import { useState } from "react";
import { Paperclip } from "lucide-react";
import { Button } from "../components/charte";
import { http } from "../api/http";
export type NoteExtrasData = {
  files?: Array<{ id: string; name: string; size: number }>;
  mentions?: Array<{ id: string; firstName: string; lastName: string }>;
  resolvedReferences?: Array<{
    entityType: string;
    entityId: string;
    available: boolean;
    label?: string;
  }>;
};
export function TeamNoteExtras({
  id,
  data,
}: {
  id: string;
  data: NoteExtrasData;
}) {
  const [error, setError] = useState("");
  async function download(file: NonNullable<NoteExtrasData["files"]>[number]) {
    try {
      setError("");
      const { data: blob } = await http.get<Blob>(
        `/v1/workspace/notes/${id}/files/${file.id}`,
        { responseType: "blob" },
      );
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = file.name;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch {
      setError("Pièce jointe indisponible ou partage retiré.");
    }
  }
  return (
    <div className="space-y-4">
      {!!data.mentions?.length && (
        <p className="text-sm text-secondary">
          Personnes mentionnées :{" "}
          <span className="font-medium text-body">
            {data.mentions.map((m) => m.firstName + " " + m.lastName).join(", ")}
          </span>
        </p>
      )}

      {!!data.files?.length && (
        <div className="space-y-2">
          <h3 className="text-eyebrow uppercase text-secondary">Pièces jointes</h3>
          <div className="flex flex-wrap gap-2">
            {data.files.map((f) => (
              <Button key={f.id} size="sm" icon={Paperclip} onClick={() => void download(f)}>
                {f.name} · {Math.ceil(f.size / 1024)} Ko
              </Button>
            ))}
          </div>
        </div>
      )}
      {error && (
        <p role="alert" className="rounded-xl bg-danger-light px-3 py-2 text-sm text-danger-dark">
          {error}
        </p>
      )}
    </div>
  );
}
